module.exports = __webpack_public_path__ + "static/Smart Logistics Solutions-896f27f897d60b11d492356d59837a04.pdf";